export default "__VITE_ASSET__7efad820__"